import {Injectable} from '@angular/core';
import {filter} from 'rxjs/operators';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {NotificationService} from '@shared/services/notification.service';

@Injectable({
  providedIn: 'root',
})
export class RouteInterceptor {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private notificationService: NotificationService
  ) {
  }

  init(): void {
    this.setSubscription();
  }

  setSubscription() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.onNavigationEnd());
  }

  onNavigationEnd(): void {
    this.interceptNotification();
  }

  interceptNotification(): void {
    const newNotificationId = parseInt(this.route.snapshot.queryParamMap.get('notificationId'), 10) || null;
    if (newNotificationId) {
      this.onNewNotificaction(newNotificationId);
      this.router.navigate([], {relativeTo: this.route, replaceUrl: true});
    }
  }

  async onNewNotificaction(newNotificationId: number): Promise<void> {
    await this.notificationService.markNotificationRead(newNotificationId);
    await this.notificationService.resetNotificationPending();
  }
}
